  import LoginPage                 from "views/Login/LoginPage.jsx";
  import TrackTransfer             from "views/TrackTransfer/TrackTransfer.jsx";
  import HistoryList               from "views/History/HistoryList.jsx";
  import HistoryDetail             from "views/History/HistoryDetail.jsx";
  import HistoryChange             from "views/History/HistoryChange.jsx";
  import HistoryRefund             from "views/History/HistoryRefund.jsx";
  import TransferOnline1           from "views/TransferOnline/TransferOnline1.jsx";
  import TransferOnline2           from "views/TransferOnline/TransferOnline2.jsx";
  import TransferOnline3           from "views/TransferOnline/TransferOnline3.jsx";
  import TransferOnlineLogin       from "views/TransferOnline/TransferOnlineLogin.jsx";
  import TransferOnlineCards       from "views/TransferOnline/TransferOnlineCards.jsx";
  import TransferOnline4b          from "views/TransferOnline/TransferOnline4b.jsx";
  import TransferOnline4c          from "views/TransferOnline/TransferOnline4c.jsx";
  import TransferOnline4c2         from "views/TransferOnline/TransferOnline4c2.jsx";
  import TransferOnline4c3         from "views/TransferOnline/TransferOnline4c3.jsx";
  import RegisterLight1            from "views/Register/RegisterLight1.jsx";
  import RegisterLight1OTP         from "views/Register/RegisterLight1OTP.jsx";
  import RegisterLight1Login       from "views/Register/RegisterLight1Login.jsx";
  import RegisterLightInfo         from "views/Register/RegisterLightInfo.jsx";
  import RegisterLight2            from "views/Register/RegisterLight2.jsx";
  import RegisterLight2BP          from "views/Register/RegisterLight2BP.jsx";
  import RegisterLight3            from "views/Register/RegisterLight3.jsx";
  import RegisterLight4            from "views/Register/RegisterLight4.jsx";
  import RegisterLight5IdBoxInfo   from "views/Register/RegisterLight5IdBoxInfo.jsx";
  import RegisterIdBoxSuccess      from "views/Register/RegisterIdBoxSuccess.jsx";
  import RegisterLightEndBP        from "views/Register/RegisterLightEndBP.jsx";
  import RegisterLightStore        from "views/Register/RegisterLightStore.jsx";
  import ForgotPass1               from "views/ForgotPass/ForgotPass1.jsx";
  import ForgotPass2               from "views/ForgotPass/ForgotPass2.jsx";
  import ForgotPass3               from "views/ForgotPass/ForgotPass3.jsx";
  import StoreLocator              from "views/StoreLocator/StoreLocator.jsx";
  import SettingsMain              from "views/Settings/SettingsMain.jsx";
  import SettingsChangePass        from "views/Settings/SettingsChangePass.jsx";
  import SettingsChangeMobile      from "views/Settings/SettingsChangeMobile.jsx";
  import SettingsProfileIdDetails  from "views/Settings/SettingsProfileIdDetails.jsx";
  import SettingsProfilePersonal   from "views/Settings/SettingsProfilePersonal.jsx";
  import SettingsHelp              from "views/Settings/SettingsHelp.jsx";
  import SettingsPrivacy           from "views/Settings/SettingsPrivacy.jsx";
  import SettingsTerms             from "views/Settings/SettingsTerms.jsx";
  import SettingsTermsBills        from "views/Settings/SettingsTermsBills.jsx";
//import ScanDocuments             from "views/ScanDocuments/ScanDocuments.jsx";
  //-------------
  //Bills Section
  //-------------
  import Bills                     from "views/Bills/Bills.jsx";
  import BillsCategories           from "views/Bills/BillsCategories.jsx";
  import BillsCompanies            from "views/Bills/BillsCompanies.jsx";
//import BillsScanner              from "views/Bills/BillsScanner.jsx";
  import BillsHistory              from "views/Bills/BillsHistory.jsx";
  import BillsHistoryDetail        from "views/Bills/BillsHistoryDetail.jsx";
  import BillsFavorites            from "views/Bills/BillsFavorites.jsx";
  import BillsFavoritesDetail      from "views/Bills/BillsFavoritesDetail.jsx";
  import BillsPaymentSetup         from "views/Bills/BillsPaymentSetup.jsx";
  import BillsPaymentReview        from "views/Bills/BillsPaymentReview.jsx";
  //------------
  //Card Section
  //------------
  import CardList                  from "views/Cards/CardList.jsx";
  //------------
  //More Section
  //------------
  import More                      from "views/More/More.jsx";

  import CustomerConfirm           from "views/CustomerConfirm/CustomerConfirm.jsx";

// @material-ui/icons
import TempIcon              from "@material-ui/icons/ExitToApp";

var dashRoutes = [
  {
    path           : "/auth",
    name           : "auth",
    icon           : TempIcon,
    component      : LoginPage,
    displaySidebar : true
  },
  {
    path           : "/TrackTransfer",
    name           : "TrackTransfer",
    icon           : TempIcon,
    component      : TrackTransfer,
    displaySidebar : true
  },
  {
    path           : "/HistoryList",
    name           : "HistoryList",
    icon           : TempIcon,
    component      : HistoryList,
    displaySidebar : true
  },
  {
    path           : "/HistoryDetail",
    name           : "HistoryDetail",
    icon           : TempIcon,
    component      : HistoryDetail,
    displaySidebar : true
  },
  {
    path           : "/HistoryChange",
    name           : "HistoryChange",
    icon           : TempIcon,
    component      : HistoryChange,
    displaySidebar : true
  },
  {
    path           : "/HistoryRefund",
    name           : "HistoryRefund",
    icon           : TempIcon,
    component      : HistoryRefund,
    displaySidebar : true
  },
  {
    path           : "/TransferOnline1",
    name           : "Αποστολή Χρημάτων",
    icon           : TempIcon,
    component      : TransferOnline1,
    displaySidebar : true
  },
  {
    path           : "/TransferOnline2",
    name           : "TransferOnline2",
    icon           : TempIcon,
    component      : TransferOnline2,
    displaySidebar : true
  },
  {
    path           : "/TransferOnline3",
    name           : "TransferOnline3",
    icon           : TempIcon,
    component      : TransferOnline3,
    displaySidebar : true
  },
  {
    path           : "/TransferOnlineLogin",
    name           : "TransferOnlineLogin",
    icon           : TempIcon,
    component      : TransferOnlineLogin,
    displaySidebar : true
  },
  {
    path           : "/TransferOnlineCards",
    name           : "TransferOnlineCards",
    icon           : TempIcon,
    component      : TransferOnlineCards,
    displaySidebar : true
  },
  {
    path           : "/TransferOnline4b",
    name           : "TransferOnline4b",
    icon           : TempIcon,
    component      : TransferOnline4b,
    displaySidebar : true
  },
  {
    path           : "/TransferOnline4c",
    name           : "TransferOnline4c",
    icon           : TempIcon,
    component      : TransferOnline4c,
    displaySidebar : true
  },
  {
    path           : "/TransferOnline4c2",
    name           : "TransferOnline4c2",
    icon           : TempIcon,
    component      : TransferOnline4c2,
    displaySidebar : true
  },
  {
    path           : "/TransferOnline4c3",
    name           : "TransferOnline4c3",
    icon           : TempIcon,
    component      : TransferOnline4c3,
    displaySidebar : true
  },
  {
    path           : "/RegisterLight1",
    name           : "RegisterLight1",
    icon           : TempIcon,
    component      : RegisterLight1,
    displaySidebar : true
  },
  {
    path           : "/RegisterLight1OTP",
    name           : "RegisterLight1OTP",
    icon           : TempIcon,
    component      : RegisterLight1OTP,
    displaySidebar : true
  },
  {
    path           : "/RegisterLight1Login",
    name           : "RegisterLight1Login",
    icon           : TempIcon,
    component      : RegisterLight1Login,
    displaySidebar : true
  },
  {
    path           : "/RegisterLightInfo",
    name           : "RegisterLightInfo",
    icon           : TempIcon,
    component      : RegisterLightInfo,
    displaySidebar : true
  },
  {
    path           : "/RegisterLight2",
    name           : "RegisterLight2",
    icon           : TempIcon,
    component      : RegisterLight2,
    displaySidebar : true
  },
  {
    path           : "/RegisterLight2BP",
    name           : "RegisterLight2BP",
    icon           : TempIcon,
    component      : RegisterLight2BP,
    displaySidebar : true
  },
  {
    path           : "/RegisterLight3",
    name           : "RegisterLight3",
    icon           : TempIcon,
    component      : RegisterLight3,
    displaySidebar : true
  },
  {
    path           : "/RegisterLight4",
    name           : "RegisterLight4",
    icon           : TempIcon,
    component      : RegisterLight4,
    displaySidebar : true
  },
  {
    path           : "/RegisterLight5IdBoxInfo",
    name           : "RegisterLight5IdBoxInfo",
    icon           : TempIcon,
    component      : RegisterLight5IdBoxInfo,
    displaySidebar : true
  },
  {
    path           : "/RegisterIdBoxSuccess",
    name           : "RegisterIdBoxSuccess",
    icon           : TempIcon,
    component      : RegisterIdBoxSuccess,
    displaySidebar : true
  },
  {
    path           : "/RegisterLightEndBP",
    name           : "RegisterLightEndBP",
    icon           : TempIcon,
    component      : RegisterLightEndBP,
    displaySidebar : true
  },
  {
    path           : "/RegisterLightStore",
    name           : "RegisterLightStore",
    icon           : TempIcon,
    component      : RegisterLightStore,
    displaySidebar : true
  },
  {
    path           : "/ForgotPass1",
    name           : "ForgotPass1",
    icon           : TempIcon,
    component      : ForgotPass1,
    displaySidebar : true
  },
  {
    path           : "/ForgotPass2",
    name           : "ForgotPass2",
    icon           : TempIcon,
    component      : ForgotPass2,
    displaySidebar : true
  },
  {
    path           : "/ForgotPass3",
    name           : "ForgotPass3",
    icon           : TempIcon,
    component      : ForgotPass3,
    displaySidebar : true
  },
  {
    path           : "/StoreLocator",
    name           : "StoreLocator",
    icon           : TempIcon,
    component      : StoreLocator,
    displaySidebar : true
  },
  {
    path           : "/SettingsMain",
    name           : "v",
    icon           : TempIcon,
    component      : SettingsMain,
    displaySidebar : true
  },
  {
    path           : "/SettingsChangePass",
    name           : "SettingsChangePass",
    icon           : TempIcon,
    component      : SettingsChangePass,
    displaySidebar : true
  },
  {
    path           : "/SettingsChangeMobile",
    name           : "SettingsChangeMobile",
    icon           : TempIcon,
    component      : SettingsChangeMobile,
    displaySidebar : true
  },
  {
    path           : "/SettingsProfileIdDetails",
    name           : "SettingsProfileIdDetails",
    icon           : TempIcon,
    component      : SettingsProfileIdDetails,
    displaySidebar : true
  },
  {
    path           : "/SettingsProfilePersonal",
    name           : "SettingsProfilePersonal",
    icon           : TempIcon,
    component      : SettingsProfilePersonal,
    displaySidebar : true
  },
  {
    path           : "/SettingsHelp",
    name           : "SettingsHelp",
    icon           : TempIcon,
    component      : SettingsHelp,
    displaySidebar : true
  },
  {
    path           : "/SettingsPrivacy",
    name           : "SettingsPrivacy",
    icon           : TempIcon,
    component      : SettingsPrivacy,
    displaySidebar : true
  },
  {
    path           : "/SettingsTerms",
    name           : "SettingsTerms",
    icon           : TempIcon,
    component      : SettingsTerms,
    displaySidebar : true
  },
  {
    path           : "/SettingsTermsBills",
    name           : "SettingsTermsBills",
    icon           : TempIcon,
    component      : SettingsTermsBills,
    displaySidebar : true
  },
  // {
  //   path           : "/SettingsProfile1",
  //   name           : "SettingsProfile1",
  //   icon           : TempIcon,
  //   component      : SettingsProfile1,
  //   displaySidebar : true
  // },
  // {
  //   path           : "/SettingsProfile2",
  //   name           : "SettingsProfile2",
  //   icon           : TempIcon,
  //   component      : SettingsProfile2,
  //   displaySidebar : true
  // },
  // {
  //   path           : "/SettingsProfile3",
  //   name           : "SettingsProfile3",
  //   icon           : TempIcon,
  //   component      : SettingsProfile3,
  //   displaySidebar : true
  // },
  // {
  //   path           : "/ScanDocuments",
  //   name           : "ScanDocuments",
  //   icon           : TempIcon,
  //   component      : ScanDocuments,
  //   displaySidebar : true
  // },
  //-------------
  //Bills Section
  //-------------
  {
    path           : "/Bills",
    name           : "Bills",
    icon           : TempIcon,
    component      : Bills,
    displaySidebar : true
  },
  {
    path           : "/BillsCategories",
    name           : "BillsCategories",
    icon           : TempIcon,
    component      : BillsCategories,
    displaySidebar : true
  },
  {
    path           : "/BillsCompanies",
    name           : "BillsCompanies",
    icon           : TempIcon,
    component      : BillsCompanies,
    displaySidebar : true
  },
  // {
  //   path           : "/BillsScanner",
  //   name           : "BillsScanner",
  //   icon           : TempIcon,
  //   component      : BillsScanner,
  //   displaySidebar : true
  // },
  {
    path           : "/BillsHistory",
    name           : "BillsHistory",
    icon           : TempIcon,
    component      : BillsHistory,
    displaySidebar : true
  },
  {
    path           : "/BillsHistoryDetail",
    name           : "BillsHistoryDetail",
    icon           : TempIcon,
    component      : BillsHistoryDetail,
    displaySidebar : true
  },
  {
    path           : "/BillsFavorites",
    name           : "BillsFavorites",
    icon           : TempIcon,
    component      : BillsFavorites,
    displaySidebar : true
  },
  {
    path           : "/BillsFavoritesDetail",
    name           : "BillsFavoritesDetail",
    icon           : TempIcon,
    component      : BillsFavoritesDetail,
    displaySidebar : true
  },
  {
    path           : "/BillsPaymentSetup",
    name           : "BillsPaymentSetup",
    icon           : TempIcon,
    component      : BillsPaymentSetup,
    displaySidebar : true
  },
  {
    path           : "/BillsPaymentReview",
    name           : "BillsPaymentReview",
    icon           : TempIcon,
    component      : BillsPaymentReview,
    displaySidebar : true
  },
  //-------------
  //More Section
  //-------------
  {
    path           : "/More",
    name           : "More",
    icon           : TempIcon,
    component      : More,
    displaySidebar : true
  },
  {
    path           : "/CustomerConfirm",
    name           : "CustomerConfirm",
    icon           : TempIcon,
    component      : CustomerConfirm,
    displaySidebar : true
  },
  //-------------
  //Card Section
  //-------------
  {
    path           : "/CardList",
    name           : "CardList",
    icon           : TempIcon,
    component      : CardList,
    displaySidebar : true
  }
];
export default dashRoutes;
